import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import AntdBreadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";
import "./index.scss";
import MainconternLayout from "../../../components/Layout/MainconternLayout";

const StoreLinks = () => {
  const {
    register,
    getValues,
    setValue,
    // formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);
  const [editSuccess, setEditSuccess] = useState(false);
  // const navigate = useNavigate();
  const [id, setId] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_API_URL}store-link/list`)
      .then((res) => {
        setId(res.data.rows[0]._id);
        setCount(res.data.count);
        Object.keys(res.data.rows[0]).forEach((x) => {
          setValue(x, res.data.rows[0][x]);
        });
      });
  }, [count, setValue]);

  const onSubmit = (fields) => {
    if (count === 0) {
      axios
        .post(`${process.env.REACT_APP_API_URL}store-link/create`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else if (count === 1) {
      let fields = getValues();
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}store-link/update/${id}`,
          fields,
        )
        .then((response) => {
          if (response.data?._id) {
            setEditSuccess(true);
          } else {
            alert("Fail");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Settings",
        link: "/settings-social-media-link",
      },
      { text: "Play Store / App Store Links", link: "" },
    ],
    [],
  );

  return (
    <>
      <MainconternLayout
        header={
          <AntdBreadcrumbs
            className="healthsyMasterBreadCrumbs"
            breadcrumbsList={breadcrumbsList}
          />
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-6">
                <label
                  className="car-dep-form-txt mb-2"
                  style={{ color: "#4B4853" }}
                  htmlFor=""
                >
                  Play Store Link{" "}
                </label>
                <input
                  className="form-control w-75"
                  type="text"
                  name=""
                  id="type"
                  {...register("playStore", { required: false })}
                  placeholder="Type here..."
                />
              </div>

              <div className="col-6">
                <label
                  className="car-dep-form-txt mb-2"
                  style={{ color: "#4B4853" }}
                  htmlFor=""
                >
                  App Store Link{" "}
                </label>
                <input
                  className="form-control w-75"
                  type="text"
                  name=""
                  id="type"
                  {...register("appStore", { required: false })}
                  placeholder="Type here..."
                />
              </div>
            </div>

            <div className="car-dep-form-button">
              <button type="submit">SUBMIT</button>
            </div>
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={"/store-links"}
          name="Play Store / App Store Links"
          post="posted"
        />
      )}

      {editSuccess && (
        <SucessModal
          page={"/store-links"}
          name="Play Store / App Store Links"
          post="updated"
        />
      )}
    </>
  );
};

export default StoreLinks;
